// export const BASE_URL = "https://www.mumblit.com/mobile_api/";
export const BASE_URL = "https://mumblit-widget-api-seven.vercel.app";
// export const BASE_URL =
//   "https://mumblit-widget-38775ep4h-nicholas-szankovics-s-projects.vercel.app";
